import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnBW: CultureInfo = {
  name: 'en-BW',
  displayName: 'English (Botswana)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-BW',
  parent: CultureInfoEn
};
